<script>
  import { MediaType, MediaSlider, datePrettify, isDev, imgSrc, store } from '$client';
  export let data;
  const { city } = store;
  $: ({ media, medias } = data);
  $: mediaSource = media?.pageImg?.data?.attributes ?? media?.cardImg?.data?.attributes;
  $: date = media.date ?? media.updatedAt ?? media.publishedAt ?? media.createdAt;
</script>

<article id="main" class="margin-block container" itemscope itemtype="https://schema.org/NewsArticle">
  <MediaType type={media.type} />
  <h1 itemprop="headline name" class="h1">{media.header}</h1>
  <time itemprop="datePublished" datetime={date}>{datePrettify('D.M.Y', date)}</time>
  {#if !media.video}
    <img
      itemprop="image"
      width={mediaSource.width}
      height={mediaSource.height}
      src={imgSrc(mediaSource.url)}
      alt={mediaSource.alternativeText} />
  {:else}
    <div id="video-player">{@html JSON.parse(media.video).rawData.html}</div>
  {/if}
  <div id="content" class="custom-page" itemprop="articleBody">
    {@html media.page}
  </div>
  <meta itemprop="author" value="uberi" />
  <div itemprop="publisher" itemscope="" itemtype="https://schema.org/Organization">
    <div itemprop="logo" itemscope="" itemtype="https://schema.org/ImageObject">
      <img itemprop="image" src="/favicon.svg" alt="" title="" style="display:none;" />
    </div>
    <meta itemprop="name" content="uberi.pro" />
    <meta itemprop="telephone" content={$city.phone} />
    <meta itemprop="address" content={$city.region} />
  </div>
  {#if medias.length > 0 || isDev()}
    <footer>
      <MediaSlider data={medias} type="white" header="Другие новости" />
    </footer>
  {/if}
</article>

<style lang="scss">
  #main {
    font-family: Roboto;

    > h1 {
      font-weight: 800;
      font-family: Vela Sans;
      margin-block: 12px;
    }

    > time {
      display: block;
      color: rgb(44 51 60 / 100%);
      font-size: 18px;

      @media only screen and (max-width: 575.98px) {
        text-align: center;
      }
    }

    > img {
      width: 100%;
      height: 100%;
      max-height: 640px;
      object-fit: cover;
      overflow: hidden;
      border-radius: 15px;
      margin-block: 56px;

      @media only screen and (max-width: 767.98px) {
        aspect-ratio: 2 / 1;
        height: auto;
      }
    }

    > #video-player {
      position: relative;
      width: 100%;
      height: 0;
      max-height: 640px;
      padding-bottom: 56.25%; /* задаёт высоту контейнера для 16:9 (если 4:3 — поставьте 75%) */
      overflow: hidden;
      border-radius: 15px;
      margin-block: 56px;

      :global(iframe) {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        height: 100%;
        max-height: 100%;
        object-fit: cover;
        border-width: 0;
        outline-width: 0;
      }
    }
  }

  #content {
    display: flex;
    flex-direction: column;
    gap: 28px;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 1.5%;

    @media only screen and (max-width: 500px) {
      font-size: 18px;
    }
  }
</style>
